import { getTemplateNavHeaderBasicStyles } from '../NavHeader-Level0/NavHeader-Level0.styles'
import type {} from '../Global/global'

const t = document.createElement('template')
t.innerHTML = `
<div class="navheader-utility">
  <slot></slot>
</div>
`
class NavHeaderLevel0Utility extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderBasicStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUtility connectedCallback: ', this)
  }
}

if (!customElements.get('ts-navheader-level0-utility')) {
  customElements.define('ts-navheader-level0-utility', NavHeaderLevel0Utility)
}
export { NavHeaderLevel0Utility }
